<app-card [titleKey]="title()">
  <app-person-contact-form
    [formGroup]="formGroup()"
    [showTitle]="showTitle()"
    [disabled]="disabled()"
  />
</app-card>
